import React, { useCallback, useEffect, useState } from "react";
import { useTypedDispatch, useTypedSelector } from "store";
import {
  getSubjectDeffenseById,
  getSubjectDeffensePlay,
  getSubjectHandPlay,
  getSubjectHandPlayById
} from "store/game/thunkActions";
import { setGameMultiple, setSimpleField } from "store/game/slice";
import { useNavigate } from "react-router-dom";
import { setTriggerAlert } from "store/users/slice";
import PracticeByTechniqueTabDesktop from "./PracticeByTechniqueTabDesktop";
import PracticeByTechniqueMobile from "./PracticeByTechniqueMobile";
import { showMobile } from "helpers/adaptation";
import SubscriptionPopup from "common/components/SubscriptionPopup";
import { localStorageKeys } from "config/localStorageKeys";

export interface PracticeByTechniqueTabProps {
  type?: "deffense" | "hand_play";
  search?: any;
}

const PracticeByTechniqueTab = ({ type, search }: PracticeByTechniqueTabProps) => {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();

  const { subscriptionValid } = useTypedSelector((store) => store.user.client);

  const [isShowExpired, setIsShowExpired] = useState(false);

  const [listChecked, setListChecked] = useState([]);
  const [data, setData] = useState<any>({
    basic: [],
    middle: [],
    hard: []
  });

  useEffect(() => {
    const compareFunc = (a: any, b: any) => a.Data?.SbjIndex - b.Data?.SbjIndex;
    const getData = async () => {
      try {
        let res: any = {};
        if (type === "hand_play") {
          res = await dispatch(getSubjectHandPlay());
        } else {
          res = await dispatch(getSubjectDeffensePlay());
        }

        if (res.data?.Results && res.data?.Results?.length > 0) {
          const basic: any[] = [];
          const middle: any[] = [];
          const hard: any[] = [];
          res.data?.Results.forEach((val: any) => {
            switch (val?.Data?.SbjCategoryID) {
              case 10:
                basic.push(val);
                break;
              case 20:
                middle.push(val);
                break;
              case 30:
                hard.push(val);
                break;
            }
          });
          setData({
            basic: basic.sort(compareFunc),
            middle: middle.sort(compareFunc),
            hard: hard.sort(compareFunc)
          });
        }
      } catch {
        //
      }
    };
    getData();
  }, [dispatch, type]);

  const onChecked = (val: any, item: any) => {
    if (item.target.checked) {
      const boofer: any = [...listChecked];
      const findIndex = boofer.findIndex((val_find: any) => val_find === val?.Data?.Id_ExSubject);
      if (findIndex === -1) {
        boofer.push(val?.Data?.Id_ExSubject);
        setListChecked(boofer);
      }
    } else {
      const boofer = [...listChecked];
      const findIndex = boofer.findIndex((val_find) => val_find === val?.Data?.Id_ExSubject);
      if (findIndex !== -1) {
        boofer.splice(findIndex, 1);
        setListChecked(boofer);
      }
    }
  };

  const onStartPractice = useCallback(async () => {
    if (!subscriptionValid) {
      return setIsShowExpired(true);
    }
    if (type === "hand_play") {
      dispatch(
        setSimpleField({
          type: "subject_hand_play",
          value: listChecked.join(",")
        })
      );
      localStorage.setItem("subject_hand_play", listChecked.join(","));
    } else if (type === "deffense") {
      dispatch(
        setSimpleField({
          type: "subject_deffense_play",
          value: listChecked.join(",")
        })
      );
      localStorage.setItem("subject_deffense_play", listChecked.join(","));
    }
    if (type === "hand_play") {
      try {
        const res: any = await dispatch(getSubjectHandPlayById());
        let gameId = null;
        let courseId = null;
        let gameName = null;
        let globalGameId = null;

        let arrResult: any[] = [];

        const resLevels = localStorage.getItem("levels");
        const audit: number[] = [];
        if (resLevels) {
          const valLevel = JSON.parse(resLevels);
          if (valLevel?.ease) {
            audit.push(10);
          }
          if (valLevel?.medium) {
            audit.push(20);
          }
          if (valLevel?.hard) {
            audit.push(30);
          }
        }

        if (res?.Results && res?.Results?.length > 0 && audit.length > 0) {
          res?.Results?.forEach((item: any) => {
            const findItem = audit.find((val_audit) => val_audit === item?.Level);
            if (findItem) {
              arrResult.push(item);
            }
          });
        } else {
          // eslint-disable-next-line no-unsafe-optional-chaining
          arrResult = [...res?.Results];
        }

        if (arrResult.length === 0) {
          return dispatch(
            setTriggerAlert({
              show: true,
              title: "No exercise"
            })
          );
        }

        if (arrResult && arrResult?.length > 0) {
          gameId = arrResult[0]?.ExIndex;
          courseId = arrResult[0]?.CategoryId;
          gameName = `${arrResult[0]?.Title1 || ""} ${arrResult[0]?.Title2 || ""}`;
          globalGameId = arrResult[0]?.Id_PHExercise;
        }
        const data = {
          gameId,
          courseId,
          gameName,
          globalGameId
        };
        dispatch(
          setGameMultiple({
            type_game: "handPlay",
            data
          })
        );
        localStorage.setItem(localStorageKeys.handPlayExercises, "");
        localStorage.setItem("hand_play_exercise", JSON.stringify(data));
        localStorage.setItem(localStorageKeys.reloadPageShuffle, "true");
        navigate("/hand_play?subject=true");
      } catch {
        //
      }
    } else if (type === "deffense") {
      const res: any = await dispatch(getSubjectDeffenseById());

      let arrResult: any[] = [];

      const resLevels = localStorage.getItem("levels");
      const audit: number[] = [];
      if (resLevels) {
        const valLevel = JSON.parse(resLevels);
        if (valLevel?.ease) {
          audit.push(10);
        }
        if (valLevel?.medium) {
          audit.push(20);
        }
        if (valLevel?.hard) {
          audit.push(30);
        }
      }

      if (res?.Results && res?.Results?.length > 0 && audit.length > 0) {
        res?.Results?.forEach((item: any) => {
          const findItem = audit.find((val_audit) => val_audit === item?.Level);
          if (findItem) {
            arrResult.push(item);
          }
        });
      } else {
        // eslint-disable-next-line no-unsafe-optional-chaining
        arrResult = [...res?.Results];
      }

      if (arrResult.length === 0) {
        return dispatch(
          setTriggerAlert({
            show: true,
            title: "No exercise"
          })
        );
      }
      const data = {
        gameId: arrResult[0]?.ExIndex,
        courseId: arrResult[0]?.CategoryId,
        globalGameId: arrResult[0]?.Id_PHExercise,
        gameName: ""
      };
      localStorage.setItem("deffense_exercise", JSON.stringify(data));
      localStorage.setItem(localStorageKeys.reloadPageShuffle, "true");

      dispatch(
        setGameMultiple({
          type_game: "deffense",
          data
        })
      );
      navigate("/deffense_play?subject=true");
    }
  }, [dispatch, listChecked, navigate, type, subscriptionValid]);

  return (
    <>
      {!showMobile && (
        <PracticeByTechniqueTabDesktop
          onStartPractice={onStartPractice}
          onChecked={onChecked}
          type={type}
          search={search}
          listChecked={listChecked}
          data={data}
        />
      )}
      {showMobile && (
        <PracticeByTechniqueMobile
          onStartPractice={onStartPractice}
          onChecked={onChecked}
          type={type}
          search={search}
          listChecked={listChecked}
          data={data}
        />
      )}
      <SubscriptionPopup
        modalHeight={showMobile ? "calc(100vh - 100px)" : "calc(100vh - 120px)"}
        show={isShowExpired}
        onHide={() => setIsShowExpired(false)}
      />
    </>
  );
};

export default PracticeByTechniqueTab;
